export default __webpack_public_path__ + "static/smart-grid-1ef36dea0a8b0c92210dbaad73272588.png";